export const printA4 = (elementId, filenameData = {}) => {
    const el = document.getElementById(elementId);
    if (!el) {
        console.error(`Element not found: ${elementId}`);
        return;
    }

    // 1. 파일명 생성 로직 (기존과 동일)
    const { year, month, customerName } = filenameData;
    const now = new Date();
    const timestamp =
        now.getFullYear().toString() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        String(now.getHours()).padStart(2, '0') +
        String(now.getMinutes()).padStart(2, '0') +
        String(now.getSeconds()).padStart(2, '0');

    const shortYear = String(year).slice(-2);
    const safeCustomerName = customerName || '거래처미정';
    const docTitle = `장비대금청구서_${shortYear}년${month}월_${safeCustomerName}_${timestamp}`;

    // 현재 페이지 제목 임시 교체 (안드로이드/PC 해결책)
    // 브라우저가 iframe 인쇄 시에도 부모 창의 제목을 파일명으로 쓰는 경우가 많음
    const originalTitle = document.title; // 원래 제목 저장
    document.title = docTitle;            // 파일명으로 제목 변경

    // 2. 인쇄 내용 가져오기
    const printContents = el.innerHTML;

    // 3. CSS 스타일 정의 (기존 스타일 + 모바일용 폰트 로딩 최적화)
    const styles = `
        /* 기본 초기화 */
        * { box-sizing: border-box; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        body { font-family: "Noto Sans KR", sans-serif; margin: 0; padding: 0; background: #fff; }
        
        /* A4 설정 */
        @page { size: A4 portrait; margin: 5mm; }

        /* 레이아웃 Wrapper */
        .print-page-wrapper { width: 200mm; min-height: 287mm; margin: 0 auto; position: relative; padding: 8mm 8mm; }

        /* 유틸리티 */
        .text-center { text-align: center !important; }
        .text-right { text-align: right !important; }
        .text-left { text-align: left !important; }
        .font-weight-bold { font-weight: 700 !important; }
        .mb-4 { margin-bottom: 1rem !important; }
        .d-flex { display: flex !important; }
        .justify-content-between { justify-content: space-between !important; }
        .align-items-center { align-items: center !important; }

        /* 타이틀 */
        .print-main-title { font-size: 22pt; font-weight: 900; margin-top: 0; margin-bottom: 20px; text-decoration: underline; text-underline-offset: 4px; text-align: center; }
        
        /* 상단 정보 */
        .print-header-container { align-items: flex-end; margin-bottom: 15px; }
        .print-header-left { display: flex; flex-direction: column; justify-content: flex-end; width: 45%; align-items: flex-start; }
        .print-header-right { width: 55%; display: flex; justify-content: flex-end; }
        
        .print-date-large { font-size: 15pt; font-weight: 900; margin-bottom: 2px; color: #000; }
        .print-customer-large { font-size: 15pt; font-weight: 900; border-bottom: 2px solid #000; padding-bottom: 2px; margin-bottom: 5px; display: inline-block; }
        .print-notice { font-size: 10pt; font-weight: 700; }

        /* 공급자 테이블 */
        .provider-table-v2 { width: 100%; border-collapse: collapse; border: 1px solid #000; font-size: 9pt; }
        .provider-table-v2 td { border: 1px solid #000; padding: 2px 4px; height: 22px; vertical-align: middle; }
        .table-label-v2, .table-sub-label-v2 { background-color: #f2f2f2; font-weight: bold; text-align: center; white-space: nowrap; }
        .table-value-v2 { padding-left: 8px; letter-spacing: -0.5px; }

        /* 공급자 테이블 컬럼 너비 강제 조정 */
        // 첫 번째 컬럼 (라벨: 상호, 주소 등) - Width 15%
        .provider-table-v2 tr:nth-child(2) td:nth-child(1), 
        .provider-table-v2 tr:nth-child(4) td:nth-child(1),
        .provider-table-v2 tr:nth-child(5) td:nth-child(1) { width: 15%; }
        
        // 두 번째 컬럼 (값: 회사명, 전화번호 등) - Width 50%
        .provider-table-v2 tr:nth-child(2) td:nth-child(2), 
        .provider-table-v2 tr:nth-child(4) td:nth-child(2),
        .provider-table-v2 tr:nth-child(5) td:nth-child(2) { width: 50%; }
        
        // 세 번째 컬럼 (라벨: 성명, FAX 등) - Width 15%
        .provider-table-v2 tr:nth-child(2) td:nth-child(3), 
        .provider-table-v2 tr:nth-child(4) td:nth-child(3),
        .provider-table-v2 tr:nth-child(5) td:nth-child(3) { width: 15%; }
        
        // 네 번째 컬럼 (값: 이름, 팩스번호 등) - Width 20%
        .provider-table-v2 tr:nth-child(2) td:nth-child(4), 
        .provider-table-v2 tr:nth-child(4) td:nth-child(4),
        .provider-table-v2 tr:nth-child(5) td:nth-child(4) { width: 20%; }

        /* 메인 상세 테이블 */
        .main-print-table { width: 100%; border-collapse: collapse; margin-top: 10px; border: 1px solid #000; table-layout: fixed; font-size: 9pt; }
        .main-print-table th { background-color: #f2f2f2; border: 1px solid #000; padding: 4px 2px; font-weight: bold; text-align: center; white-space: nowrap; height: 26px; }
        .main-print-table td { border: 1px solid #000; padding: 2px 2px; vertical-align: middle; height: 23px; }

        /* 컬럼별 너비 및 정렬 */
        .main-print-table th:nth-child(1), .main-print-table td:nth-child(1) { width: 11%; white-space: nowrap; letter-spacing: -0.5px; text-align: center; }
        .main-print-table th:nth-child(2), .main-print-table td:nth-child(2) { width: 14%; letter-spacing: -0.5px; text-align: center; }
        .main-print-table th:nth-child(3), .main-print-table td:nth-child(3) { width: 7%; text-align: center; }
        .main-print-table th:nth-child(4) { width: 11%; text-align: center; }
        .main-print-table td:nth-child(4) { width: 11%; text-align: right; padding-right: 5px; }
        .main-print-table th:nth-child(5) { width: 6%; text-align: center; }
        .main-print-table td:nth-child(5) { width: 6%; text-align: right; padding-right: 12px; }
        .main-print-table th:nth-child(6) { width: 12%; text-align: center; }
        .main-print-table td:nth-child(6) { width: 12%; text-align: right; padding-right: 5px; }
        .main-print-table th:nth-child(7) { width: 10%; text-align: center; }
        .main-print-table td:nth-child(7) { width: 10%; text-align: right; padding-right: 5px; }
        .main-print-table th:nth-child(8) { width: auto; text-align: center; }
        .main-print-table td:nth-child(8) { width: auto; text-align: left; padding-left: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        /* 하단 합계 테이블 */
        .summary-horizontal-table { width: 100%; border-collapse: collapse; border: 1px solid #000; border-top: none; font-size: 10pt; table-layout: fixed; margin-top: 2px; }
        .summary-th { background-color: #f2f2f2; border: 1px solid #000; padding: 6px 2px; font-weight: bold; text-align: center; width: 10%; white-space: nowrap; letter-spacing: -1px; }
        .summary-td { border: 1px solid #000; padding: 6px 2px; text-align: center; font-weight: bold; white-space: nowrap; width: 15%; letter-spacing: -0.5px; }
        .highlight-label { background-color: #e0e0e0; width: 12%; }
        .highlight-value { background-color: #e0e0e0; font-size: 12pt; width: 18%; }

        /* 도장 및 기타 */
        .seal-container { position: relative; display: inline-block; vertical-align: middle; width: 50px; height: 10px; }
        .seal-image-print { position: absolute; top: -18px; left: 0px; width: 40px; height: 40px; opacity: 0.8; z-index: 10; object-fit: contain; }
        .seal-mark { color: #888; font-size: 8pt; position: absolute; top: -5px; left: 5px; }
        .print-footer-date { margin-top: 15px; text-align: center; font-size: 10pt; font-weight: bold; }
    `;

    // 4. Iframe 생성 (팝업 대신 사용)
    let iframe = document.getElementById('print-iframe');
    if (iframe) {
        document.body.removeChild(iframe);
    }

    iframe = document.createElement('iframe');
    iframe.id = 'print-iframe';
    // iframe을 화면에서 숨김 (display:none은 인쇄가 안될 수 있으므로 visibility 사용)
    iframe.style.position = 'absolute';
    iframe.style.width = '0px';
    iframe.style.height = '0px';
    iframe.style.top = '-1000px';
    iframe.style.left = '-1000px';
    iframe.style.border = 'none';

    document.body.appendChild(iframe);

    // 5. Iframe에 HTML 쓰기
    const doc = iframe.contentWindow.document;

    const html = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>${docTitle}</title>
            <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700;900&display=swap" rel="stylesheet">
            <style>${styles}</style>
        </head>
        <body>
            <div class="print-page-wrapper">
                ${printContents}
            </div>
        </body>
        </html>
    `;

    doc.open();
    doc.write(html);
    doc.close();

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        // 아이폰이면 그냥 팝업(새 탭)으로 띄움 (가장 안전)
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            alert('팝업 차단을 해제해주세요.');
            // 차단 시 제목 복구
            document.title = originalTitle;
            return;
        }

        printWindow.document.write(html);
        printWindow.document.close();
        // 약간의 딜레이 후 인쇄
        setTimeout(() => {
            // PDF 파일명 적용 (아이폰 팝업용)
            printWindow.document.title = docTitle;
            printWindow.focus();
            printWindow.print();
        }, 1000);
    } else {
        // 인쇄 실행 (모바일 렌더링 대기)
        setTimeout(() => {
            // 인쇄 직전에 Iframe 문서의 타이틀을 다시 한번 명시적으로 설정 ▼▼▼
            iframe.contentWindow.document.title = docTitle;
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }, 1000); // 1초 대기 후 인쇄
    }

    // 제목 복구 (인쇄 다이얼로그가 충분히 뜬 후 복구)
    // 너무 빨리 복구하면 파일명이 다시 원래대로 돌아갈 수 있으므로 3초 뒤 복구
    setTimeout(() => {
        document.title = originalTitle;
    }, 3000);
};
